import { render, staticRenderFns } from "./MarcaForm.vue?vue&type=template&id=387e41d5"
import script from "./MarcaForm.vue?vue&type=script&lang=js"
export * from "./MarcaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports